import { useState } from "react";
import { user_register } from "../../utils/endpoints";
import SignInConfirm from "./SignInConfirm";
import InformativaAppaltatore from "../../assets/partials/InformativaAppaltatore";
import InformativaGestore from "../../assets/partials/InformativaGestore";


export default function PrivacyConsent({ context, user_data, is_appaltatore }) {
  const [disable_confirm, setDisableConfirm] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage(null);

    try {
      const response = await context.httpRequest("post", user_register, user_data);

      if (!!response && response.result) {
        document.querySelector(".main-panel")?.classList.add("remove-main-panel");
        context.openModal(<SignInConfirm context={context} />, false);
      } else {
        setErrorMessage("Si è verificato un errore. Riprova più tardi.");
        if (!response?.error) {
          context.openMessage("danger", "Errore imprevisto durante la registrazione.");
        }
      }
    } catch (error) {
      setErrorMessage("Si è verificato un errore. Riprova più tardi.");
      context.openMessage("danger", "Errore imprevisto durante la registrazione.");
    }
  };

  return (
    <>
      {is_appaltatore ? <InformativaAppaltatore /> : <InformativaGestore />}

      <form className="mt-3" onSubmit={handleSubmit}>
        <div className="mb-4 d-flex align-items-center">
          <input
            onChange={() => setDisableConfirm(!disable_confirm)}
            id="consent-give"
            type="checkbox"
            required
          />
          <label className="ms-2 fw-bold" htmlFor="consent-give">
            Accetto le condizioni sulla privacy
          </label>
        </div>

        {errorMessage && (
          <div className="alert alert-danger" role="alert">
            {errorMessage}
          </div>
        )}

        <button
          style={{ opacity: disable_confirm ? "0.5" : 1 }}
          className="q8-blue-button p-3 w-100"
          type="submit"
          disabled={disable_confirm}
        >
          CONFERMA
        </button>
      </form>
    </>
  );
}